/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Tag } from 'antd'
import { omit } from 'lodash'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'

const { CheckableTag } = Tag

const I2TagSelectControl = (props) => {
  const {
    propsClassName, propsClassSpan, style,// 样式 className
    modalProps, label, radio,// 组件 功能参数
    options, query, value, searchKey, // 组件 数据源
    clearKey, killPending, reduxObj,// 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props

  const handleValue = Object.keys(query).includes(searchKey)
    ? query[searchKey].toString().split(',')
    : []
  // 初始化Tag选择状态
  const [ useValue, setUseValue ] = useState(handleValue)
  useEffect(() => {
    setUseValue(handleValue)
  }, [query.refQ, query[searchKey]])

  const onChangeSelect = (value, state) => {
    let formatValue = useValue
    // 单选数据处理
    if (radio) {
      formatValue = state
        ? [value]
        : useValue
    } else {
      formatValue = state
        ? [...formatValue, value]
        : formatValue.filter(ele => ele!== value)
    }
    setUseValue(formatValue)
    // ----- 提交组件 -----------
    handleControl(
      props,
      { [searchKey]: formatValue.join(',') }
    )
  }
  return (
    <div className={`${propsClassName} i2-radio-tag` }>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      {options.map(item => {
        return (
          <CheckableTag
            {...modalProps}
            key={item.id}
            checked={useValue.includes(item.id)}
            onChange={(state => onChangeSelect(item.id, state))}
          >
            {item.value}
          </CheckableTag>
        )
      })}
    </div>
  )
}

export default I2TagSelectControl

I2TagSelectControl.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  query: {},
  options: [],
  killPending: false,
  radio: false // 是否单选
}